import { Button, Heading, Text } from "@growtherapy/sprout-ui";
import PreSessionImage from "../assets/images/pre-session-image.svg?react";

export function LoginSuccessPage() {
  const params = new URLSearchParams(window.location.search);
  const isInSession = params.get("isInSession") === "true";

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-6 bg-neutral-300 px-16">
      <div className="hidden sm:block">
        <PreSessionImage aria-label="A light purple sketch of a pair of hands clasped together." />
      </div>
      <Heading variant="3xl" className="font-normal text-center" as="h1">
        Login successful
      </Heading>
      <Text as="div" className="text-neutral-700 text-center">
        Welcome back! You can now close this window
        {isInSession ? " and return to your session." : "."}
      </Text>
      <Button onClick={window.close}>Close window</Button>
    </div>
  );
}
